var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 50,
  height: 30,
  viewBox: "0 0 38 38"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.847 19.015a9.365 9.365 0 1 1 9.365-9.365 9.373 9.373 0 0 1-9.365 9.365zm0-17.877a8.52 8.52 0 1 0 0 17.04 8.52 8.52 0 0 0 0-17.04z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.724 19.015a9.365 9.365 0 1 1 9.357-9.365 9.373 9.373 0 0 1-9.357 9.365zm0-17.877a8.52 8.52 0 1 0-.017 17.04 8.52 8.52 0 0 0 .017-17.04zM9.847 36.883a9.356 9.356 0 1 1 9.365-9.356 9.365 9.365 0 0 1-9.365 9.356zm0-17.868a8.512 8.512 0 1 0 8.52 8.512 8.52 8.52 0 0 0-8.52-8.512z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.724 36.883a9.356 9.356 0 1 1 9.357-9.356 9.365 9.365 0 0 1-9.357 9.356zm0-17.868a8.512 8.512 0 1 0 8.512 8.512 8.52 8.52 0 0 0-8.512-8.512z"
}))));
export default __webpack_public_path__ + "teg/media/solid.f00fcf79.svg";
export { SvgComponent as ReactComponent };